import { useNavigate, useParams } from "react-router-dom";
import { useBackdropState } from "../../BackDrop/BackDropProvider";

function useOnClickFunctions() {
  const { removeOpenedBy } = useBackdropState();
  const navigate = useNavigate();
  const { restaurantId, tableId } = useParams();

  const handleClose = () => {
    removeOpenedBy("transparent-drawer");
    // Close returns to the bill summary, not the table's starting page — same
    // destination as the TransparentDrawer's close and the backdrop's reset.
    navigate(`/restaurants/${restaurantId}/tables/${tableId}/bills`);
  };

  const handleNavigate = (path: string) => {
    requestAnimationFrame(() => {
      navigate(path);
    });
  };

  return { handleClose, handleNavigate };
}

export default useOnClickFunctions;
